// #region CONSTANTES
// Types de paiement
export const PAYZEN = 2;
export const PAYZEN_TPE = 3;
export const TPE = "TPE";
// #endregion
